import { gql } from "@apollo/client";

const TOTALCHATCOUNTSUBSCRIPTION = gql`
  subscription totalchatcountchanged {
    totalchatcountchanged {
      success
      error
      result
    }
  }
`;
export default TOTALCHATCOUNTSUBSCRIPTION;
